import React from 'react';
import { PLUGIN_TOOLBAR_BUTTON_ID, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { getVisibleOnlyOnDesktopResolver } from 'wix-rich-content-plugin-commons';
import { AlignmentPanel, NodeAlignmentButton } from 'wix-rich-content-toolbars-ui';
import { buttonsModals } from './constants.js';
import ButtonSettingsModal from './modals/SettingsModal.js';
import 'ricos-schema';
import './types.js';
import 'ricos-context';
import './modals/SettingsModalContent.js';
import '@wix/design-system';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import './style-inject.es-e7b07dd7.js';
import './components/design-component.js';
import './dataHooks.js';
import './utils/resolve-colors.js';
import './defaults.js';
import './components/settings-component.js';
import 'ricos-content';

const getToolbarButtons = (config, services, type) => {
  const {
    context: { isMobile }
  } = services;
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: buttonsModals.alignment[type]
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: buttonsModals.alignment[type] })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      modal: {
        Component: decorateComponentWithProps(ButtonSettingsModal, {
          modalId: buttonsModals.settings[type]
        }),
        id: buttonsModals.settings[type]
      },
      command: ({ isMobile: isMobile2, attributes: { selectedNode } }) => {
        services.modals.openModal(buttonsModals.settings[type], {
          componentProps: {
            nodeId: selectedNode.attrs.id,
            settings: config,
            type
          },
          positioning: { placement: "right" },
          layout: isMobile2 ? "fullscreen" : "drawer"
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};

export { getToolbarButtons };
//# sourceMappingURL=getToolbarButtons.js.map
